var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "accordion" + _vm.index } },
    _vm._l(_vm.childrens, function (item, idx) {
      return _c("div", { key: idx, staticClass: "card accordion" }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: {
              id: "heading" + item.id + _vm.index,
              "data-toggle": "collapse",
              "data-target": "#collapse" + item.id + _vm.index,
              "aria-expanded": _vm.index == 0 && _vm.numChilds == 1,
              "aria-controls": "collapse" + item.id + _vm.index,
            },
          },
          [
            _c(
              "div",
              { staticClass: "row no-gutters" },
              [
                _c(
                  "div",
                  {
                    staticClass: "col",
                    class: { "tbl-column-disabled": !item.active },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.name) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.checkActions
                  ? _c("column-actions", {
                      staticClass: "col-auto d-flex justify-content-end",
                      attrs: {
                        tag: "div",
                        listClass: "actions",
                        routeEdit: _vm.routeGroupEdit,
                        deleteMsgTemplate: "global.msg.confirm.delete-group",
                        canDetail: _vm.canDetail,
                        canEdit: _vm.canEdit,
                        canDelete: _vm.canDelete,
                        row: item,
                        index: idx,
                        callbackDelete: _vm.onRemove,
                      },
                      on: { delete: _vm.deleteItem },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse",
            class: { show: _vm.index == 0 && _vm.numChilds == 1 },
            attrs: {
              id: "collapse" + item.id + _vm.index,
              "aria-labelledby": "heading" + item.id + _vm.index,
              "data-parent": "#accordion" + _vm.index,
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("table-data", {
                  attrs: {
                    showTitleData: false,
                    data: _vm.children(item.children),
                    settings: _vm.table.settings,
                    columns: _vm.table.columns,
                    tableWrapperClass: "table-responsive",
                    inlineFilters: _vm.table.filters,
                    autoUpdateFilter: _vm.table.autoUpdateFilter,
                    addParamsToUrl: _vm.table.addParamsToUrl,
                    loadingMsg: _vm.table.loadingMsg,
                    notFoundMsg: _vm.table.notFoundMsg,
                    orderByTemplate: _vm.table.orderByTemplate,
                    showPagination: _vm.table.showPagination,
                    tableInline: _vm.table.tableInline,
                    isRecursive: true,
                  },
                  on: { "error-load": _vm.showError },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function ({ row, index, remove }) {
                          return [
                            _c(
                              "td",
                              { class: { "tbl-column-disabled": !row.active } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(row.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.checkActions
                              ? _c("column-actions", {
                                  attrs: {
                                    routeEdit: _vm.routeItemEdit,
                                    canDetail: _vm.canDetail,
                                    canEdit: _vm.canEdit,
                                    canDelete: _vm.canDelete,
                                    row: row,
                                    index: index,
                                    callbackDelete: remove,
                                  },
                                  on: { delete: _vm.deleteItem },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                item.children.length > 0
                  ? _c("recursive-list", {
                      staticClass: "mb-3",
                      attrs: {
                        list: item.children,
                        checkActions: _vm.checkActions,
                        routeItemEdit: _vm.routeItemEdit,
                        routeGroupEdit: _vm.routeGroupEdit,
                        moduleId: _vm.moduleId,
                        canDetail: _vm.canDetail,
                        canEdit: _vm.canEdit,
                        canDelete: _vm.canDelete,
                        onRemove: _vm.onRemove,
                        deleteItem: _vm.deleteItem,
                        table: _vm.table,
                        showError: _vm.showError,
                        index: _vm.index + 1,
                        pageCode: _vm.pageCode,
                        targetField: _vm.targetField,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }